import React from 'react';
import './App.css';
import ProductItem from './ProductItem.js';
import EditProductItem from './EditProductItem.js';
import Image from 'react-bootstrap/Image'
import 'bootstrap/dist/css/bootstrap.css';

class GridItem extends React.Component {
	constructor(props) {
	    super(props);

	    this.state = {
	      	addProduct:false,
	      	insertAtproduct:null,
	    }
  	}

	handlePromoClick(product){
		//console.log(product);
		this.props.onAddPromoClick(product);
	}

	handleAddProductClick(product){
		
		this.setState({
			addProduct:true,
			insertAtproduct:product,
		});	
	}

	handleProductAdded(stylecode){
		//retrieve new product
		this.setState({
			addProduct:false
		});

		this.props.onAddProductClick(this.state.insertAtproduct,stylecode);
	}

	handleDeleteProduct(styleCode){
		this.props.onDeleteProductClick(styleCode);		
	}


	handleHideProduct(product){
		this.props.onHideProductClick(product);		
	}

	handleProductClick(product){
		this.props.onProductClick(product);
	}

	renderProduct(p){		
		return <ProductItem 
		editable={this.props.editable}
		product={p} 
		onProductClick={(product)=>this.handleProductClick(product)}
		onAddProductClick={(product) => this.handleAddProductClick(product)}
		onAddPromoClick={(product) => this.handlePromoClick(product)}
		onDeleteProductClick={(stylecode)=>this.handleDeleteProduct(stylecode)}
		onHideProduct={(product)=>this.handleHideProduct(product)}
		onSearchPromoImage={(product) => this.props.onSearchPromoImage(product)} 
		onEditProduct={(productpk)=>this.props.onEditProduct(productpk)}/>
	}

	classList(product){
		var retv = 'product-tiles-grid-item-detail ';
		
		if (this.props.viewMobile && !product.isPromo) retv += ' col-md-6 ';
		if (!this.props.viewMobile && !product.isPromo) retv += ' col-md-3 ';
		if (this.props.viewMobile && product.isPromo) retv += ' col-md-12 ';
		if (!this.props.viewMobile && product.isPromo) retv += ' col-md-6 ';
		/*
		MI = missing image flag/property
		IE = image error
		Fxy  = show image (X == true)

					Fxy
			MI	IE
			T	T	X
			T	F	
			F	T	X
			F	F	X
		*/
		if (this.props.missingImages && !product.isErrorImg) retv += ' hideMissingImage ';
		if (product.isOver) retv += ' hoverHandle ';
						  
		return retv;
	}	

	render() {  
	    return (
	    	<div id="grid" className={this.props.viewMobile?'gridMobile':'grid'}>
	    		<EditProductItem action='Add' shouldShow={this.state.addProduct} 
	    		onClose={()=>this.setState({addProduct:false})} 
	    		onProductAdded={(stylecode=>this.handleProductAdded(stylecode))}/>
		    	<center>
			    	<div style={{width: (this.props.viewMobile ? '50%' : '90%')}}>	    		
			    		<Image src={this.props.heroImageUrl} className="heroImg" rounded={true}/>
			    		<div className="row">
				    		{this.props.products.map((product) => {
				    				
									//console.log('>>> ' + this.props.viewMobile + '-' + !product.isPromo + '=' + (this.props.viewMobile && !product.isPromo));
									return(
										<div draggable
						    				onDragStart={(e) => {if (this.props.editable) this.handleDragStart(e,product)}}
						    				onDragOver={(e) => {if (this.props.editable) this.props.onHandleDragOver(e,product)}}
						    				onDrop={(e) => {if (this.props.editable) this.props.onHandleDrop(e,product)}}		    									    				
						    				className= {this.classList(product)} 
						    				style={{opacity:product.isHidden?'0.2':'1'}}
						    				key={product.pk}
						    				>
						    					{this.renderProduct(product)} 
						    			</div>
							  		);
				    		})}
			    		</div>
			    	</div>
			    </center>
	    	</div>
	    	
	    );
  	}

  	handleDragStart(e,product){
  		e.dataTransfer.setData('text/plain',product.pk);
  	}
  	
}

export default GridItem;